module.exports = __webpack_public_path__ + "img/content-revision.625e4d6a.webp";